import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
    private _refreshTokenUrl = environment.baseUrl + 'token/refresh/';
    private _onAuthenticated = new EventEmitter<void>();
    get onAuthenticateEmitter() {
        return this._onAuthenticated.asObservable();
    }
    private _onLogout = new EventEmitter<void>();
    get onLogoutEmitter() {
        return this._onLogout.asObservable();
    }
    get accessToken() {
        const token = localStorage.getItem("accessToken");
        if (token) {
            return token;
        } else {
            return 'none';
        }
    }
    set accessToken(value: string) {
        localStorage.setItem("accessToken", value);
    }

    get refreshToken() {
        const token = localStorage.getItem("refreshToken");
        if (token) {
            return token;
        } else {
            return 'none';
        }
    }
    set refreshToken(value: string) {
        localStorage.setItem("refreshToken", value);
    }
    constructor(
        private _http: HttpClient,
        public _router: Router,
    ) { }
    isAuthenticated(): boolean {
        const authStatus = localStorage.getItem('isAuthenticated');
        if (authStatus) {
            return authStatus === "true"
        } else {
            return false;
        }
    }

    login() {
        localStorage.setItem("isAuthenticated", "true");
        this._onAuthenticated.emit()
    }

    logout(): void {
        localStorage.setItem("isAuthenticated", "false");
        localStorage.clear();
        this._onLogout.emit();
        this._router.navigateByUrl('/auth/logout')
    }

    refreshTokenResolver(): Observable<{ access: string }> {
        console.log(this.refreshToken, 'in auth service');
        if (!this.refreshToken || this.refreshToken === 'none') {
            this.logout();
        }

        return this._http.post<{ access: string }>(this._refreshTokenUrl, { refresh: this.refreshToken });
    }

}